module.exports = _.curry;